import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./RefundToken.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import PinIcon from "../../Assets/Images/Sustenance/pinIcon.svg";
import { Card } from "@mui/material";
//
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
//service
import {
  getAssignedToken,
  updateLeadStatus,
  updateLeadTokenStatus,
} from "../../Services/AssignNewToken";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { tokenRefundRequest } from "../../Services/Tokens";
import { uniqBy } from "lodash";
import { style } from "@mui/system";
import { addLeadLogs, updateLeadAllStatus } from "../../Services/Lead";
import { Network } from "@capacitor/network";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  tokenName: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
    marginTop: "1rem",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },
}));

export default function RefundToken({
  open,
  handleClose,
  returnRes,
  data,
  refundTokenData,
}) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [assignedToken, setAssignedToken] = useState([]);
  const [assignTokenData, setAssignTokenData] = useState({
    selectedToken: "",
  });
  const [helperText, setHelperText] = useState({
    selectedToken: "",
  });
  const [uniqueToken, setUniqueToken] = useState([]);
  const [tokenInfo, setTokenInfo] = useState([]);
  const [reason, setReason] = useState("");
  const [selectedTokenData, setSelectedTokenData] = useState(null);
  // useEffect(() => {
  //   getAssignedToken(data?.leadId)
  //     .then((resp) => {
  //       console.log(resp);
  //       resp = resp.map((token) => ({
  //         ...token,
  //         tokenName: token.eventTokenId.tokenId.name,
  //       }));

  //       setUniqueToken(uniqBy(resp, "tokenName"));
  //       setAssignedToken(resp);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  function closeModal() {
    handleClose();
  }
  // function validate() {
  //   var form = true;
  //   if (assignTokenData.selectedToken === "") {
  //     setHelperText((pre) => {
  //       pre.selectedToken = "Please select token first";
  //       return { ...pre };
  //     });
  //   } else {
  //     if (selectedTokenData === null) {
  //       form = false;
  //       errorTost("Please select Token from token Info");
  //     } else if (
  //       selectedTokenData?.eventTokenId?.tokenId?.isRefundable === false
  //     ) {
  //       form = false;
  //       errorTost("This token is not Refundable");
  //     }
  //   }

  //   return {
  //     flag: form,
  //   };
  // }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  function save() {
    //refund Token query
    handleClose();
    const refundPendingData = refundTokenData?.TokenRefundRequests.find((item)=>item.status==="pending");
    if (!refundPendingData) {
      Network.getStatus().then((status) => {
        if (status.connected) {
          tokenRefundRequest(
            loggedInUser.userId,
            refundTokenData.paymentId,
            reason,
            "pending"
          )
            .then((resp) => {
              updateLeadAllStatus(data?.leadId, "Token Refund Requested")
                .then((updateLeadStatus) => {
                  let obj = {
                    leadId: data?.leadId,
                    leadStatus: `Token Refund Requested`,
                    message: `Token Refund Requested by ${loggedInUser.name}(${loggedInUser?.roleId?.title}.Reason for token refund ${reason}`,
                  };
                  addLeadLogs(obj)
                    .then((leadLog) => {
                    })
                    .catch((err) => {
                      console.log("leadlog", err);
                    });
                  // !token status also change from complete to refund requested
                  updateLeadTokenStatus(
                    data?.leadId,
                    "refund requested",
                    refundTokenData.paymentId
                  )
                    .then((resp) => {
                      returnRes(true);
                    })
                    .catch((errResp) => {
                      console.log(
                        errResp,
                        "err while updating eventTokenLeadRelation"
                      );
                    });
                  successTost(
                    `${data?.leadname} has requested for refund Token successfully`
                  );

                  closeModal();
                })
                .catch((errWhileUpdating) => {
                  console.log("error while updating lead status");
                });
            })
            .catch((err) => {
              console.log(err);
              errorTost(err.message);
            });
        } else {
          offlineToast();
        }
      });
    } else {
      errorTost("This token is already in process");
    }
  }
  return (
    <Modal
      open={true}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Refund Token</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperTable}>
            <div className={cssClasses.blockLabel}>
              Token Info:
              {/* <span style={{ color: "red" }}> *</span> */}
            </div>
            {refundTokenData && (
              <Card className={cssClasses.tokenCard}>
                <div className={cssClasses.labelValue}>
                  <div>
                    <span className={classes.tokenName}>
                      {refundTokenData?.tokenName}
                    </span>
                  </div>
                  <div>
                    <span className={classes.labelValue}>
                      {refundTokenData?.eventTokenId?.tokenId?.inventoryTypeId
                        ?.type
                        ? refundTokenData?.eventTokenId?.tokenId
                            ?.inventoryTypeId?.type
                        : refundTokenData?.type}
                    </span>
                  </div>
                  <div>
                    <span className={classes.labelValue}>
                      ₹{numberWithCommas(refundTokenData?.amount)}
                    </span>
                  </div>
                  {/* <div>
                     <span className={classes.labelValue}>
                     ₹{numberWithCommas(refundTokenData?.paidAmount)}
                     </span>
                   </div> */}
                  <div>
                    {refundTokenData?.eventTokenId?.tokenId?.amount
                      ?.isRefundable && (
                      <span className={classes.labelCard}>Refundable</span>
                    )}

                    {refundTokenData?.TokenRefundRequests?.length > 0 && (
                      <LeadStatusChip
                        style={{
                          color: "#FF4405",
                          backgroundColor: "#FFE6D5",
                        }}
                        label={
                          "Refund Status:" +
                          refundTokenData?.TokenRefundRequests[0]?.status
                        }
                        icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                      />
                    )}
                  </div>
                </div>
              </Card>
            )}
            {refundTokenData?.paidAmount && (
              <div
                className={cssClasses.wrapperBlock}
                style={{ marginBottom: "1.2rem" }}
              >
                <div
                  className={cssClasses.blockLabel}
                  style={{
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  <span>Amount Paid: </span>{" "}
                  <span
                    className={classes.labelValue}
                    style={{ marginBottom: "0rem" }}
                  >
                    ₹{numberWithCommas(refundTokenData?.paidAmount)}
                  </span>
                </div>
              </div>
            )}

            {/* {selectedTokenData?.TokenRefundRequests?.length === 0 && ( */}
            <div className={cssClasses.wrapperBlock}>
              <div
                className={cssClasses.blockLabel}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "1rem",
                }}
              >
                <span>Reason</span>

                <div className={classes.subTitle}>
                  <TextField
                    maxRows={4}
                    value={reason}
                    onChange={(e) => {
                      e.target.value = e.target.value.trimStart();
                      if (e.target.value.length <= 200) {
                        setReason(e.target.value);
                      }
                    }}
                    placeholder={" Reason..."}
                    // helperText={helperText}
                    // error={helperText !== ""}
                    className={classes.TextFieldStyle}
                    InputProps={{
                      className: classes.inputStyle,
                    }}
                    inputProps={{ min: 0 }}
                    // FormHelperTextProps={{ className: classes.helperText }}
                    multiline
                  />
                </div>
              </div>
            </div>
            {/* )} */}
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={() => {
                closeModal();
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
                opacity:
                  selectedTokenData?.TokenRefundRequests?.length === 0
                    ? 1
                    : 0.7,
              }}
              btnName={"Raise a request"}
              clicked={() => {
                save();
              }}
              //   disable={disabeNext}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
